import { ScaleVisualization } from '~src/interfaces/scale.interface';

export type ScaleTypeIcons = 'iconStar' | 'iconSquare10' | 'iconSquareDots' | 'iconMcq';

export interface ScaleTypes {
  value: ScaleVisualization;
  name: string;
  iconName: ScaleTypeIcons;
  description: string;
  viewBoxWidth?: number;
}

export const scaleTypes: ScaleTypes[] = [
  {
    value: ScaleVisualization.Stars,
    name: 'x.scale.type.stars',
    iconName: 'iconStar',
    description: 'x.scales.add.stars.description',
  },
  {
    value: ScaleVisualization.Nps,
    name: 'x.scale.type.nps',
    iconName: 'iconSquare10',
    description: 'x.scales.add.nps.description',
    viewBoxWidth: 60,
  },
  {
    value: ScaleVisualization.Labels,
    name: 'x.scale.type.labels',
    iconName: 'iconSquareDots',
    description: 'x.scales.add.labels.description',
    viewBoxWidth: 60,
  },
  {
    value: ScaleVisualization.McqOptions,
    name: 'x.scale.type.options',
    iconName: 'iconMcq',
    description: 'x.scales.add.options.description',
  },
];
